import React from "react";
import styled from "styled-components";

const AdminNavigationTab = React.forwardRef(function AdminNavigationTab(
  {
    active = false,
    children,
    className,
    controls,
    disabled = false,
    icon = null,
    type = "button",
    "aria-label": ariaLabel,
    ...nativeProps
  },
  ref
) {
  const resolvedTabIndex =
    nativeProps.tabIndex
    ?? (active ? 0 : -1);

  return (
    <TabButton
      {...nativeProps}
      ref={ref}
      type={type}
      role="tab"
      className={className}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-selected={active}
      tabIndex={resolvedTabIndex}
      aria-controls={controls || undefined}
      $active={active}
    >
      {icon ? <TabIcon aria-hidden="true">{icon}</TabIcon> : null}
      <TabLabel>{children}</TabLabel>
    </TabButton>
  );
});

AdminNavigationTab.displayName = "AdminNavigationTab";

const TabButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.5rem;
  padding: 0.625rem 0.875rem;
  border: 1px solid
    ${({ $active }) => ($active ? "rgba(37, 99, 235, 0.55)" : "rgba(148, 163, 184, 0.35)")};
  border-radius: 0.75rem;
  background: ${({ $active }) =>
    $active ? "rgba(37, 99, 235, 0.12)" : "rgba(255, 255, 255, 0.7)"};
  color: ${({ $active }) => ($active ? "#1d4ed8" : "#334155")};
  font: inherit;
  font-weight: ${({ $active }) => ($active ? 700 : 600)};
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background-color 140ms ease,
    border-color 140ms ease,
    color 140ms ease,
    transform 140ms ease;

  &:hover:not(:disabled) {
    border-color: rgba(37, 99, 235, 0.55);
    background: ${({ $active }) =>
      $active ? "rgba(37, 99, 235, 0.16)" : "rgba(37, 99, 235, 0.08)"};
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:focus-visible {
    outline: 3px solid rgba(37, 99, 235, 0.3);
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const TabIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
`;

const TabLabel = styled.span`
  min-width: 0;
`;

export default AdminNavigationTab;
